/**
 * Константы для модуля истории поиска
 * # ⛓️ CURSOR_ANCHOR:search:history-constants
 */

// Ключи для localStorage
var SEARCH_HISTORY_KEY = 'slovary-search-history';
var SEARCH_HISTORY_DISABLED_KEY = 'slovary-search-history-disabled';
var SETTINGS_LANGS_KEY = 'slovary-hidden-langs';
var SETTINGS_DICTS_KEY = 'slovary-hidden-dicts';
var SETTINGS_CLICK_SEARCH_KEY = 'slovary-click-search';

// Экспортируем константы в глобальную область видимости
window.SEARCH_HISTORY_KEY = SEARCH_HISTORY_KEY;
window.SEARCH_HISTORY_DISABLED_KEY = SEARCH_HISTORY_DISABLED_KEY;
window.SETTINGS_LANGS_KEY = SETTINGS_LANGS_KEY;
window.SETTINGS_DICTS_KEY = SETTINGS_DICTS_KEY;
window.SETTINGS_CLICK_SEARCH_KEY = SETTINGS_CLICK_SEARCH_KEY;

// Global settings state
window.SETTINGS_CLICK_SEARCH = (function() {
  // Check cookie directly
  var name = SETTINGS_CLICK_SEARCH_KEY + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length) === 'true';
    }
  }
  return false;
})();

// Максимальное количество записей в истории
var MAX_HISTORY_ITEMS = 100000;
window.MAX_HISTORY_ITEMS = MAX_HISTORY_ITEMS;

